export default "__VITE_PUBLIC_ASSET__392a70a6__"